import { apiClient, apiEndpoint } from './api.services';
import { localStorageService } from './localStorage.service.js';
import { API } from '../constants/api.constants';
import { toasterMsg } from '../Components/Toaster/Toaster';

const bomRights = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_RIGHTS.GET}/${payload.loggedInUserId}/rights-to-access-resource`, {
      params: { devOrderId: payload.devOrderId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const userRightsService = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}/users/rights-to-access-resource`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const supplierPermissionService = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}/users/supplier-permission`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const isIdValid = (id) => {
  // Regular expression that checks for hex value
  const checkForHexRegExp = /^[0-9a-fA-F]{24}$/;
  if (typeof id === 'string') {
    return id.length === 12 || (id.length === 24 && checkForHexRegExp.test(id));
  }
};

export const isUserHaveRightsToAccessToOrder = async (params) => {
  const objLoggedInUser = localStorageService.get('loggedInUserInfo');
  if (!objLoggedInUser) {
    toasterMsg('Unauthorized Access', 'danger');
    return false;
  }

  if (objLoggedInUser.role === 'Admin') {
    return true;
  }
  const { devOrderId } = params;
  if (isIdValid(devOrderId)) {
    const res = await bomRights({
      loggedInUserId: objLoggedInUser.userId,
      devOrderId,
    });
    if (res.code === 200 && res.data) {
      return true;
    }
    toasterMsg("You've no rights to access this order.", 'danger');
  } else {
    toasterMsg('Unauthorized Access', 'danger');
  }
  return false;
};
